import React, { useState, useEffect } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import _ from "lodash";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SwalMessage from "../_Components/SwalMessage";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import ApiAmusementService from "../../../core/api/api.amusementService";
import "./style.css";
const CreateEditAmusementServicePromoCategoryCommision = () => {
  const [agentCommissionItem, setAgentCommissionItem] = useState();
  const [amusementServices, setAmusementServices] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
    getValues,
    setValue,
  } = useForm();
  let { id } = useParams();
  const navigate = useNavigate();

  const formatNumber = (value) => {
    const stringValue = String(value);
    return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleChange = (event, elementName, typeName) => {
    const numberValue = event.target.value.replace(/[^0-9]/g, "");
    setValue(elementName, formatNumber(numberValue));
    // use the below function to change other fields
    let splitElmenet = elementName.split(typeName);
    calculateOtherInputFields(splitElmenet[0], splitElmenet[1], typeName);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await ApiAgentCommission.getAgentCommissionById({
          id,
        });
        setAgentCommissionItem(response.data);
        const allAmusementServices =
          await ApiAmusementService.getAllAmusementServices();
        setAmusementServices(allAmusementServices);
        setFormStateValues(response.data, allAmusementServices);
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, []);

  const calculateOtherInputFields = (mainId, secondId, fieldType) => {
    const saleRateValue = +getValues(`${mainId}saleRate${secondId}`).replaceAll(",", "");
    const key = `${mainId}${fieldType}${secondId}`;
    const inputValue =
      fieldType === "commissionPercentage"
        ? +getValues(key)
        : +getValues(key).replaceAll(",", "");
  
    let commissionAmount, commissionPercentage, agentPaidAmount;
  
    switch (fieldType) {
      case "commissionPercentage":
        if (inputValue <= 100) {
          commissionAmount = (saleRateValue * inputValue) / 100;
          agentPaidAmount = (saleRateValue - commissionAmount) + Math.trunc(saleRateValue * 0.1);
          commissionPercentage = inputValue;
        }
        break;
  
      case "commissionAmount":
        if (inputValue <= saleRateValue) {
          commissionAmount = inputValue;
          commissionPercentage = ((inputValue / saleRateValue) * 100).toFixed();
          agentPaidAmount = (saleRateValue - commissionAmount) + Math.trunc(saleRateValue * 0.1);
        }
        break;
  
      case "agentPaidAmount":
        if (inputValue <= saleRateValue) {
          agentPaidAmount = inputValue;
          commissionAmount = saleRateValue - inputValue;
          commissionPercentage = ((commissionAmount / saleRateValue) * 100).toFixed();
        }
        break;
    }
  
    // ست کردن فرم
    setValue(`${mainId}commissionAmount${secondId}`, formatNumber(commissionAmount));
    setValue(`${mainId}commissionPercentage${secondId}`, commissionPercentage);
    setValue(`${mainId}agentPaidAmount${secondId}`, formatNumber(agentPaidAmount));
  };

  const setFormStateValues = (data, allAmusementServices) => {
    //   پر کردن نرخ فروش  برای همه آیتم‌ها
    allAmusementServices.forEach(({ id, amusementServiceReserveItems }) => {
      amusementServiceReserveItems.forEach((item) => {
        setValue(`${id}saleRate${item.id}`, formatNumber(+item.price));
      });
    });
  
    //    اگر جیسون وجود دارد، سایر مقادیر را با آن پر کن
    if (data.amusementServiceReserveItemCommissionJson) {
      const parsedJson = JSON.parse(data.amusementServiceReserveItemCommissionJson);
  
      parsedJson.forEach((item) => {
        const amusementServiceId = item.amusementServiceId;
  
        item.commissions.forEach((i) => {
          const amusementServiceReserveItemId = i.amusementServiceReserveItemId;
          const commissionPercentage = +i.commissionPercentage || 0;
          const commissionAmount = +i.commissionAmount || 0;
  
          const currentService = allAmusementServices.find((s) => s.id === amusementServiceId);
          const currentItem = currentService?.amusementServiceReserveItems?.find(
            (ai) => ai.id === amusementServiceReserveItemId
          );
          const saleRateValue = currentItem ? +currentItem.price : 0;
  
          // محاسبه مبلغ پرداختی آژانس
          const agentPaidAmount =
            (saleRateValue - commissionAmount) + Math.trunc(saleRateValue * 0.1);
  
          // ست کردن مقادیر
          setValue(
            `${amusementServiceId}commissionPercentage${amusementServiceReserveItemId}`,
            commissionPercentage
          );
          setValue(
            `${amusementServiceId}commissionAmount${amusementServiceReserveItemId}`,
            formatNumber(commissionAmount)
          );
          setValue(
            `${amusementServiceId}agentPaidAmount${amusementServiceReserveItemId}`,
            formatNumber(agentPaidAmount)
          );
        });
      });
    }
  };
  
  

  const transformFormData = (formState) => {
    const result = {};

    Object.keys(formState).forEach((key) => {
      // Extract the amusementServiceId, field type, and amusementServiceReserveItemId from the key
      const inputValue = getValues(key);
      if (inputValue && !_.isUndefined(inputValue)) {
        const match = key.match(
          /^(\d+)(commissionPercentage|commissionAmount|agentPaidAmount)(\d+)$/
        );
        if (match) {
          const amusementServiceId = parseInt(match[1]);
          const fieldType = match[2]; // Either "commissionPercentage" or "commissionAmount" or "agentPaidAmount"
          const amusementServiceReserveItemId = parseInt(match[3]);
          const value = parseFloat(
            _.isNumber(formState[key])
              ? formState[key]
              : formState[key].replaceAll(",", "")
          );

          // Initialize the amusementServiceId group if it doesn't exist
          if (!result[amusementServiceId]) {
            result[amusementServiceId] = {
              amusementServiceId,
              commissions: [],
            };
          }

          // Find or create the commission entry for the amusementServiceReserveItemId
          let commission = result[amusementServiceId].commissions.find(
            (entry) =>
              entry.amusementServiceReserveItemId ===
              amusementServiceReserveItemId
          );
          if (!commission) {
            commission = { amusementServiceReserveItemId };
            result[amusementServiceId].commissions.push(commission);
          }
          // Add the field value to the commission
          commission[fieldType] = value;
        }
      }
    });

    // Convert the grouped object to an array
    return Object.values(result);
  };

  const onSubmit = async (data) => {
    try {
      // Transform the form state
      const transformedData = transformFormData(data);
      const stringified = JSON.stringify(transformedData);
      const dataToSendServer = {
        AmusementServiceReserveItemCommissionJson: stringified,
        AgentCommissionId: +id,
      };

      let response =
        await ApiAgentCommission.editAgentCommission(dataToSendServer);

      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      if (response.succeeded) {
        navigate("/agentCommissions");
      }
    } catch (error) {
      console.log("error=", error);
    }
  };

  return (
    <>
      <div>
        <div className={`card card-custom`}>
          {/* Start Box Header */}
          <div className="card-header border-0 pb-3 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label font-weight-bolder text-dark">
                آیتم های گروه کمیسیون "{agentCommissionItem?.name}"
              </span>
              <span className="text-muted mt-3 font-weight-bold font-size-sm">
                افزودن یا ویرایش آیتم های گروه کمیسیون "
                {agentCommissionItem?.name}" برای تفریحات
              </span>
            </h3>
          </div>
          {/*Start body */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body pt-3 pb-0 border-top">
              <Row className="mt-3">
                <Col>
                  <Button
                    variant="success"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting && (
                      <Spinner animation="border" variant="warning" size="sm" />
                    )}
                    <SaveIcon /> ذخیره
                  </Button>
                  <Link className="btn btn-danger ml-3" to="/agentCommissions">
                    <CloseIcon /> بازگشت
                  </Link>
                </Col>
              </Row>
              <Row className="mt-3">
                {amusementServices?.map((service) => (
                  <Col xs="12" className="mt-3 ">
                    <Accordion key={service.id} className="border">
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${service.id}-content`}
                        id={`panel${service.id}-header`}
                      >
                        <div>{service.name}</div>
                      </AccordionSummary>
                      <AccordionDetails>
                        {service.amusementServiceReserveItems?.map(
                          (item, itemIndex) => (
                            <div
                              key={`${service.serviceId}-${item.id}`}
                              style={{ marginBottom: "1rem" }}
                            >
                              <h3 className="pb-3">{item.title}</h3>
                              <Row className="pb-4">
                                <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                                  <div className="input_container">
                                    <label>نرخ فروش</label>
                                    <input
                                      type="text"
                                      dir="ltr"
                                      placeholder="نرخ مصوب"
                                      readOnly
                                      {...register(
                                        `${service.id}saleRate${item.id}`
                                      )}
                                    />
                                  </div>
                                </Col>
                                <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                                  <div className="input_container">
                                    <label>درصد کمیسیون</label>
                                    <input
                                      type="text"
                                      dir="ltr"
                                      placeholder="درصد کمیسیون"
                                      {...register(
                                        `${service.id}commissionPercentage${item.id}`,
                                        {
                                          max: {
                                            value: 100,
                                          },
                                          min: {
                                            value: 0,
                                          },
                                        }
                                      )}
                                      onInput={(e) => {
                                        if (e.target.value > 100) {
                                          e.target.value = 100; // Limit the value to 100
                                        }
                                      }}
                                      onChange={(e) => {
                                        register(
                                          `${service.id}commissionPercentage${item.id}`
                                        ).onChange(e);
                                        calculateOtherInputFields(
                                          service.id,
                                          item.id,
                                          "commissionPercentage"
                                        );
                                      }}
                                    />
                                  </div>
                                </Col>
                                <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                                  <div className="input_container">
                                    <label> مبلغ کمیسیون</label>
                                    <input
                                      type="text"
                                      dir="ltr"
                                      placeholder="مبلغ کمیسیون"
                                      {...register(
                                        `${service.id}commissionAmount${item.id}`
                                      )}
                                      onChange={(e) =>
                                        handleChange(
                                          e,
                                          `${service.id}commissionAmount${item.id}`,
                                          "commissionAmount"
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                                  <div className="input_container">
                                    <label>مبلغ پرداختی آژانس </label>
                                    <input
                                  type="text"
                                  dir="ltr"
                                  placeholder="مبلغ پرداختی آژانس"
                                  {...register(`${service.id}agentPaidAmount${item.id}`)}
                                  readOnly
                                />

{/* 
                                    <input
                                      type="text"
                                      dir="ltr"
                                      placeholder="مبلغ پرداختی آژانس "
                                      {...register(
                                        `${service.id}agentPaidAmount${item.id}`
                                      )}
                                      onChange={(e) =>
                                        handleChange(
                                          e,
                                          `${service.id}agentPaidAmount${item.id}`,
                                          "agentPaidAmount"
                                        )
                                      }
                                      disabled="true"
                                    /> */}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          )
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </Col>
                ))}
              </Row>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

//let pricediscount =[];
// let pricediscountCommision = [];
// let percentdiscount =[];
// let percentdiscountCommision = [];
// let objData = [];
// const lastItemId = null
// const lastServiceItemId = null
// Object.keys(data).map((item) => {
//   const inputValue = getValues(item);
//   if (!_.isEmpty(inputValue) && !_.isUndefined(inputValue)) {
//     let split = [];
//     ////////////////////////////////////////////////////////////
//     // if (item.indexOf("commissionPercentage") != -1 || item.indexOf("commissionAmount") != -1 || item.indexOf("agentPaidAmount") != -1) {
//     if (!item.includes("saleRate")) {

//       if (item.indexOf("commissionPercentage") != -1) {
//         split = item.split("commissionPercentage");
//         // pricediscountCommision.push({ serviceId: split[0], serviceItemId: split[1] });
//       } else if (item.indexOf("commissionAmount") != -1) {
//         split = item.split("commissionAmount");
//         // percentdiscountCommision.push({ serviceId: split[0], serviceItemId: split[1] });
//       } else {
//         split = item.split("agentPaidAmount");

//       }

////////////////////////////////////////////////////////////
// let resITem = objData?.find((item) => item.amusementServiceId == split[0]);

// if (_.isUndefined(resITem)) {
//   objData.push({
//     amusementServiceId: split[0],
//     amusementServiceFormFieldIds: [
//       {
//         id: split[1],
//         discountpriceCommision: item.indexOf("pricediscountCommision") != -1 ? inputValue : 0,
//         discountPricePercentCommision: item.indexOf("percentdiscountCommision") != -1 ? inputValue : 0,
//       },
//     ],
//     PromoCategoryCommisionId: id,
//   });
// } else {
//   let objamusService = resITem.amusementServiceFormFieldIds.find((item) => item.id == split[1]);
//   if (_.isUndefined(objamusService)) {
//     resITem.amusementServiceFormFieldIds.push({
//       id: split[1],
//       discountpriceCommision: item.indexOf("pricediscountCommision") != -1 ? inputValue : 0,
//       discountPricePercentCommision: item.indexOf("percentdiscountCommision") != -1 ? inputValue : 0,
//     });
//   } else {
//     if (item.indexOf("pricediscountCommision") != -1) objamusService.discountpriceCommision = inputValue;
//     else if (item.indexOf("percentdiscountCommision") != -1)
//       objamusService.discountPricePercentCommision = inputValue;
//   }
// }
//     }
//   }
// });
// let tt = objData?.map((item) => {
//   return (item.amusementServiceFormFieldIds = JSON.stringify(item.amusementServiceFormFieldIds));
// });
//console.log("objDataobjData=", objData);

export default CreateEditAmusementServicePromoCategoryCommision;
